<template>
  <div class="col-md-4" :id="`user_${data.id}`">
    <div class="col-md-12 user-card" :class="{ 'inactive-user': !data.active, 'active-user': data.active }">
      <div class="custom-row">
        <div class="custom-col avatar-container">
          <img v-if="data.photo != null" :src="`/storage/${data.photo}`" alt="Imagem de perfil" class="rounded-circle"
            style="width: 100%" />
          <img v-else src="/imgs/default-profile.png" alt="Imagem de perfil" class="rounded-circle"
            style="width: 100%" />
        </div>

        <div class="custom-col info-container">
          <span class="ellipsis" :title="data.name"><strong>Nome: </strong>{{ data.name }}</span>
          <span class="ellipsis" :title="data.extension_line"><strong>Ramal: </strong>{{ data.extension_line }}</span>
          <span class="ellipsis" :title="data.login"><strong>Login: </strong>{{ data.login }}</span>
        </div>

        <div class="custom-col badge-container">
          <span v-if="data.active" class="badge active-badge">Ativo</span>
          <span v-else class="badge inactive-badge">Inativo</span>
        </div>
      </div>
      <div class="custom-row">
        <div class="col-12 text-center">
          <button :id="`editUser_${data.id}`" v-on:click="editUser()"
          class="btn btn-outline-primary hiddenButton"><i class="fas fa-edit"></i> Editar</button>
          <button :id="`deleteUser_${data.id}`" v-on:click="deleteUser()"
          class="btn btn-outline-danger hiddenButton"><i class="fas fa-times"></i> Excluir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    editUser: function () {
      $("#password, #confirmPassword").prop("required", false);
      var key = Object.keys;
      var value = Object.values;

      for (key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          $('input[name=' + key + ']').val(this.data[key]);
          $('select[name=' + key + ']').val(this.data[key]);
          if (this.data.queue) {
            $("#queue_input").val(this.data.queue);
          }

          if (this.data.queuechat) {
            $("#queuechat_input").val(this.data.queuechat);
          }

          if (this.data.photo == null) {
            $('#imagePreview').css('background-image', 'url(/imgs/default-profile.png)');
          } else {
            $('input[name=photo]').val(this.data.photo);
            $('#imagePreview').css('background-image', `url(/storage/${this.data.photo})`);
          }

        }
      }

      $(this.data.permission).each(function (index, item) {
        $('input[id=' + item + ']').prop('checked', true);
      })


      $("#usersModal").modal("show");
    },
    deleteUser: function () {
      var key = Object.keys;
      $('#deleteUserName').text(`${this.data.name}`);
      $("#deleteUserModal").modal("show");
      for (key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          $('input[name=' + key + ']').val(this.data[key]);
        }
      }
    },
    activeStatus(status) {
      return status == 1 ? "Ativo" : "Inativo";
    }
  }
};
</script>

<style scoped lang="scss">
.custom-row {
  display: flex;
  width: 100%;
  gap: 20px;
}

.custom-col {
  display: flex;
  flex-direction: column;
}

.avatar-container {
  flex: 1;
  justify-content: center;
}

.info-container {
  flex: 3;
  font-size: 12px;
  max-width: 150px;

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}

.badge-container {
  flex: 1;

  .active-badge {
    background-color: #1c869a;
    color: white;
  }

  .inactive-badge {
    background-color: #909090;
  }
}

.user-card {
  margin: 15px 0px;
  border-radius: 10px;
  background-color: #ecf0f1; padding: 15px;
}

.active-user {
  border: 1px solid #1c869a;
}

.inactive-user {
  opacity: 60%;
  border: 1px solid lightgray;
}

</style>